module.exports = __webpack_public_path__ + "static/dretch-bab7c7ce4ef69b694284abc31b7a2360.jpg";